var MessageChannelTypes;
(function (MessageChannelTypes) {
  MessageChannelTypes["BROADCAST_MESSAGES"] = "BROADCAST_MESSAGES";
  MessageChannelTypes["PORT_MESSAGES"] = "PORT_MESSAGES";
})(MessageChannelTypes || (MessageChannelTypes = {}));
export default MessageChannelTypes;